import React from "react";
import { Snackbar } from "material-ui";
import { constants } from "../../constants";

export default class InformationPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: true
    }
  }

  handleClose() {
    this.setState({
      opened: false
    })
  }

  render() {
    return(
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          open={this.state.opened}
          autoHideDuration={constants.TOAST_AUTO_HIDE_DURATION_IN_MS}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          message={this.props.message}
          onClose={() => { this.handleClose() }}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/commons/InformationPopup.js